module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/qhead7-61076acf2c3001b6fa91bff12d693450.jpg";